import apiRequest from '../apis/api-request';
import { userStore } from '../store/userStore';

const accessToken = userStore.getState().user.token;

const sbiService = {
   
    updatePayment: async (data) => {
        return apiRequest({
            method: "POST",
            url: `/api/payments/callback`,
            data: data,
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
    },
    

}

export default sbiService;